/* Mushroom Cups — custom košarica (drawer): osvježavanje, kod za popust, preporuke, progress bar dostave */
(function () {
  if (window.__mcKosarica) return;
  window.__mcKosarica = true;

  var nativeFetch = window.fetch.bind(window);
  var CART_RE = /(^|\/)cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var ADD_RE = /(^|\/)cart\/add(\.js)?(\?|$)/;
  var lastGesture = 0;
  var lastWidth = {};
  var timer = null;
  var wantOpen = false;

  ['pointerdown', 'keydown', 'submit'].forEach(function (type) {
    document.addEventListener(type, function () { lastGesture = Date.now(); }, true);
  });

  function drawer() { return document.querySelector('cart-drawer'); }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  function recentGesture() { return Date.now() - lastGesture < 5000; }

  /* Traka se pri svakom re-renderu animira od prethodne širine do nove */
  function animate() {
    document.querySelectorAll('.mc-dostava__ispuna').forEach(function (bar) {
      if (bar.__mc) return;
      bar.__mc = true;
      var key = bar.closest('cart-drawer') ? 'drawer' : 'page';
      var target = bar.style.width;
      var from = lastWidth[key];
      lastWidth[key] = target;
      if (from != null && from !== target) {
        bar.style.transition = 'none';
        bar.style.width = from;
        void bar.offsetWidth;
        bar.style.transition = '';
        bar.style.width = target;
      }
    });
  }

  /* Progress bar na /cart stranici (zasebna sekcija) */
  function refreshBars() {
    document.querySelectorAll('[data-mc-dostava-sekcija]').forEach(function (el) {
      var id = el.getAttribute('data-mc-dostava-sekcija');
      nativeFetch(window.location.pathname + '?section_id=' + encodeURIComponent(id), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var src = parse(html).querySelector('[data-mc-dostava-sekcija]');
          if (src) { el.innerHTML = src.innerHTML; animate(); }
        })
        .catch(function () {});
    });
  }

  function refresh(open) {
    refreshBars();
    var el = drawer();
    if (!el) return Promise.resolve();
    return nativeFetch(root() + '?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (sections['cart-drawer']) {
          var doc = parse(sections['cart-drawer']);
          var src = doc.querySelector('.drawer__inner');
          var dst = el.querySelector('.drawer__inner');
          var srcEl = doc.querySelector('cart-drawer');
          if (src && dst) dst.innerHTML = src.innerHTML;
          if (srcEl) el.classList.toggle('is-empty', srcEl.classList.contains('is-empty'));
        }
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']) {
          var b = parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
          if (b) bubble.innerHTML = b.innerHTML;
        }
        animate();
        if (open && typeof el.open === 'function' && !el.classList.contains('active')) el.open();
      })
      .catch(function () {});
  }

  function schedule(open) {
    wantOpen = wantOpen || open;
    clearTimeout(timer);
    timer = setTimeout(function () {
      var o = wantOpen;
      wantOpen = false;
      refresh(o);
    }, 120);
  }

  /* Dawn-ovi vlastiti pozivi šalju "sections" i sami osvježavaju drawer — njih preskačemo */
  function hasSections(body) {
    if (!body) return false;
    try {
      if (typeof body === 'string') return body.indexOf('sections') > -1;
      if (typeof FormData !== 'undefined' && body instanceof FormData) return body.has('sections');
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) return body.has('sections');
    } catch (e) {}
    return false;
  }

  /* Sva ostala dodavanja u košaricu (landeri, bundle sekcije, appovi): osvježi i otvori drawer */
  window.fetch = function (input, init) {
    var promise = nativeFetch.apply(null, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (CART_RE.test(url) && !hasSections(init && init.body)) {
        var isAdd = ADD_RE.test(url);
        promise.then(function (res) {
          if (res && res.ok) schedule(isAdd && recentGesture());
        }).catch(function () {});
      }
    } catch (e) {}
    return promise;
  };

  var xhrOpen = XMLHttpRequest.prototype.open;
  var xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__mcUrl = url;
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    try {
      var url = String(this.__mcUrl || '');
      if (CART_RE.test(url) && !hasSections(body)) {
        var isAdd = ADD_RE.test(url);
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) schedule(isAdd && recentGesture());
        });
      }
    } catch (e) {}
    return xhrSend.apply(this, arguments);
  };

  function post(path, data) {
    return nativeFetch(root() + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data),
    }).then(function (r) {
      return r.json().then(function (json) { return { ok: r.ok, data: json }; });
    });
  }

  /* Kod za popust */
  function kodBox() { return document.querySelector('cart-drawer [data-mc-kod]'); }

  function currentCodes() {
    var box = kodBox();
    if (!box) return [];
    return (box.getAttribute('data-kodovi') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  }

  function setCodes(codes, tried) {
    var box = kodBox();
    if (box) box.classList.add('is-loading');
    return post('cart/update.js', { discount: codes.join(',') })
      .then(function (res) {
        var bad = false;
        if (tried) {
          var list = (res.data && res.data.discount_codes) || [];
          var hit = list.filter(function (d) { return String(d.code).toLowerCase() === tried.toLowerCase(); })[0];
          bad = !res.ok || !hit || hit.applicable === false;
        }
        var cleanup = bad
          ? post('cart/update.js', {
              discount: codes.filter(function (c) { return c.toLowerCase() !== tried.toLowerCase(); }).join(','),
            })
          : Promise.resolve();
        return cleanup.then(function () { return refresh(false); }).then(function () {
          if (!bad) return;
          var nb = kodBox();
          var msg = nb && nb.querySelector('[data-mc-kod-poruka]');
          if (msg) {
            msg.textContent = nb.getAttribute('data-greska') || '';
            msg.hidden = false;
          }
        });
      })
      .catch(function () {
        var b = kodBox();
        if (b) b.classList.remove('is-loading');
      });
  }

  function applyCode() {
    var box = kodBox();
    var input = box && box.querySelector('[data-mc-kod-input]');
    var code = input ? input.value.trim() : '';
    if (!code) return;
    var codes = currentCodes().filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); });
    codes.push(code);
    setCodes(codes, code);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var add = target.closest('[data-mc-dodaj]');
    if (add) {
      event.preventDefault();
      if (add.disabled) return;
      add.disabled = true;
      add.classList.add('is-loading');
      post('cart/add.js', { items: [{ id: Number(add.getAttribute('data-mc-dodaj')), quantity: 1 }] })
        .then(function () { return refresh(false); })
        .catch(function () { add.disabled = false; add.classList.remove('is-loading'); });
      return;
    }

    if (target.closest('[data-mc-kod-gumb]')) {
      event.preventDefault();
      applyCode();
      return;
    }

    var remove = target.closest('[data-mc-kod-ukloni]');
    if (remove) {
      event.preventDefault();
      var gone = remove.getAttribute('data-mc-kod-ukloni').toLowerCase();
      setCodes(currentCodes().filter(function (c) { return c.toLowerCase() !== gone; }), null);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    if (event.target && event.target.matches && event.target.matches('[data-mc-kod-input]')) {
      event.preventDefault();
      applyCode();
    }
  });

  /* Ako nijedna sekcija (header) nije učitala Dawn-ov cart-drawer.js, učitaj ga ovdje */
  function ensureDrawerScript() {
    var el = drawer();
    if (!el || customElements.get('cart-drawer')) return;
    if (document.querySelector('script[src*="cart-drawer.js"]')) return;
    var src = el.getAttribute('data-drawer-js');
    if (!src) return;
    var s = document.createElement('script');
    s.src = src;
    document.head.appendChild(s);
  }

  function init() {
    var el = drawer();
    ensureDrawerScript();
    animate();
    if (el && typeof MutationObserver !== 'undefined') {
      new MutationObserver(animate).observe(el, { childList: true, subtree: true });
    }
    if (typeof window.subscribe === 'function') {
      window.subscribe('cart-update', function () { refreshBars(); });
    }
  }

  if (document.readyState === 'complete') init();
  else window.addEventListener('load', init);

  window.mcKosarica = { refresh: refresh };
})();
